var scope_0 = require('/opt/build/repo/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/83feb2b0e2466d1f307ef96f1de5f8d2.js').default;
var scope_1 = require('/opt/build/repo/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/90bc7c54163d938ee2cabb5b6cd32d01.js').default;
var scope_2 = require('/opt/build/repo/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb248f14f2cd0c256069a6068d046446.js').default;
var scope_3 = require('/opt/build/repo/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e9e800e0fef11a3db4c357f33bca5390.js').default;
var scope_4 = require('/opt/build/repo/web/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/efd431fe522cb770e483c2dad79a63a1.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    